frontApp.search = {
  name: 'search',
  description: 'Search panel in the header',
  controlEl: '.js-search-control',
  closeEl: '.js-search-close',
  panelEl: '.js-search-panel',
  isOpen: false,
  init() {
    const self = this;
    const control = document.querySelector(this.controlEl);
    if (control) {
      control.addEventListener('click', (e) => {
        e.preventDefault();
        if (self.isOpen) {
          self.close();
        } else {
          self.open();
        }
      });
    }

    const close = document.querySelector(this.closeEl);
    if (close) {
      close.addEventListener('click', () => {
        self.close();
      });
    }

    document.addEventListener('click', (e) => {
      if (
        !e.target.closest(self.panelEl)
        && !e.target.closest(self.controlEl)
        && !e.target.closest('.js-burger-menu') // burger.js
        && !e.target.closest('.js-burger-control') // burger.js
        && !e.target.closest('.js-clear-scroll-locks-prevent') // other elements
      ) {
        self.close();
      }
    });
  },
  close() {
    this.isOpen = false;
    const els = document.querySelectorAll(`${this.panelEl}, ${this.controlEl}, ${this.closeEl}`);
    els.forEach((el) => {
      el.classList.remove('is-open');
    });
    // Disabled lock body scroll
    document.body.style.marginRight = '';
    bodyScrollLock.clearAllBodyScrollLocks();
  },
  open() {
    this.isOpen = true;
    // Add active classes
    const els = document.querySelectorAll(`${this.panelEl}, ${this.controlEl}, ${this.closeEl}`);
    els.forEach((el) => {
      el.classList.add('is-open');
    });
    // Lock body scroll
    const scrollContainer = document.querySelector('.header__search-result-content');
    if (scrollContainer) {
      document.body.style.marginRight = `${(window.innerWidth - document.documentElement.clientWidth)}px`;
      bodyScrollLock.disableBodyScroll(scrollContainer);
    }
  },
};
